<template>
  <div id="car-detail">
    <div class="flex justify-space-between align-center">
      <h2 class="title"></h2>
      <router-link to="/vehicles" class="link">
        &lt; Regresar
      </router-link>
    </div>
    <div class="card flex dspl-block-sm">
      <section v-if="selectedVehicle" class="card-section vehicle-information center-text">
        <h2>{{ selectedVehicle.contract_tag }}</h2>
        <p>{{ selectedVehicle.contract_type }}</p>
        <hr class="dspl-none-sm"/>
        <p>Marca: {{ selectedVehicle.brand }}</p>
        <p>Model: {{ selectedVehicle.model }}</p>
        <p>Año: {{ selectedVehicle.year }}</p>
        <p>Caseta: {{ selectedVehicle.stall_key }}</p>
      </section>
      <hr v-if="selectedVehicle" />
      <section class="card-section grow-1">
        <div class="flex justify-space-between dspl-block-m dspl-block-sm">
          <h3> Detalle de la compra </h3>
        </div>
        <div id="textTitleContentRight">
          <template v-if="contractType !== 'Saldo'">
            <p>Nueva fecha de expiración: {{ selectedVehicleNewExpirationDate }}</p>
          </template>
          <p>Producto: {{ productName }} </p>
          <p>TAG: {{ contractTag }}</p>
          <p>Total: {{ formattedTotal }} MXN</p>
          <hr/>
          <div v-if="paymentCanProceed">
            <p>Si usted está de acuerdo con esta compra, ingrese el código de su tarjeta para finalizar el proceso</p>
            <p><label>Tarjeta</label><input :value="cardNumber" type="text" disabled></p>
            <p><label>Expiración</label><input :value="cardExpirationDate" type="text" disabled></p>
            <p><label>Cvv</label><input v-model="cardCvv" type="text" maxlength="4" placeholder="Cvv"></p>

            <router-link :to="vehicleDetailUrl">
              <button class="btn cancel">Cancelar</button>
            </router-link>
            <button @click="validateForm" class="btn accept" :disabled="isButtonDisabled">Confirmar compra</button>
          </div>
          <div v-if="paymentCannotProceed">
            <p>No es posible proceder con la transacción</p>
            <p>Motivo: {{ rationale }}</p>
            <router-link :to="vehicleDetailUrl">
              <button class="btn accept">Regresar</button>
            </router-link>
          </div>
          <div v-if="!isIVKeyValid">
            <p>No es posible proceder con la transacción</p>
            <p>Motivo: Esta compra ha expirado, favor de crear una nueva orden para proceder con el pago.</p>
            <router-link :to="vehicleDetailUrl">
              <button class="btn accept">Regresar</button>
            </router-link>
          </div>
        </div>
      </section>
    </div>
    <InformationModal
      @confirm="onModalClose"
      :active="showModal"
      title="Atención"
    >
      <template #content>
        {{ modalContent }}
      </template>
    </InformationModal>
    <ConfirmationModal
      @confirm="submitForm"
      @cancel="closeConfirmationModal"
      :active="showConfirmationModal"
      :message="confirmationModalText"
      cancel-text="Corregir CVV"
      confirm-text="Realizar el cobro"
    />
    <LoadingModal
      :active="isProcessing"
      title="Espere un momento"
    >
      <template slot="content">
        <p> Estamos procesando su cargo. . . </p>
      </template>
    </LoadingModal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ConfirmationModal from '@/components/ConfirmationModal'
import InformationModal from '@/components/InformationModal'
import LoadingModal from '@/components/LoadingModal'

export default {
  name: 'Card',
  components: {
    ConfirmationModal,
    InformationModal,
    LoadingModal
  },
  data () {
    return {
      errors: {},
      isButtonDisabled: false,
      isProcessing: false,
      modalContent: '',
      showModal: false,
      showConfirmationModal: false
    }
  },
  computed: {
    ...mapState('saleDetail', [
      'contractTag',
      'contractType',
      'processed',
      'productName',
      'rationale',
      'status',
      'validToProcess',
      'selectedVehicleId',
      'showDisplayTutorial'
    ]),
    ...mapGetters('saleDetail', [
      'cardExpirationDate',
      'cardNumber',
      'formattedTotal',
      'isIVKeyValid',
      'selectedVehicle',
      'selectedVehicleNewExpirationDate'
    ]),
    cardCvv: {
      get () { return this.$store.state.saleDetail.cardCvv },
      set (value) { this.updateCardCvv(value) }
    },
    vehicleDetailUrl () {
      return `/vehicle/${this.selectedVehicleId}`
    },
    confirmationModalText () {
      return `Ahora realizaremos el cobro a tu tarjeta, confirma que tu CVV es el siguiente: ${this.cardCvv}`
    },
    paymentCanProceed () {
      return this.validToProcess && this.isIVKeyValid && (this.processed === false)
    },
    paymentCannotProceed () {
      return !this.validToProcess && this.isIVKeyValid && (this.processed === false)
    }
  },
  watch: {
    processed (newValue, _) {
      if (newValue === true) {
        this.$nextTick(() => {
          this.changeModalMessage()
          this.isProcessing = false
          this.showModal = true
        })
      }
    }
  },
  methods: {
    ...mapActions('saleDetail', [
      'performPayment',
      'updateCardCvv'
    ]),
    changeModalMessage: function (message) {
      let content = 'Ocurrio un error inesperado, intenta nuevamente'

      if (message) {
        this.modalContent = message
      } else {
        switch (this.status) {
          case 'Duplicada':
            content = 'Su pago ya fue procesado, favor de contactar con personal de la línea Exprés en caso de cualquier duda.'
            break
          case 'Authenticada':
            content = 'Ocurrio un error y no se efectuo tu pago, intente nuevamente.'
            break
          case 'Rechazada':
            content = 'Lo sentimos, se rechazó el cobro, intente nuevamente.'
            break
          case 'Procesada':
            content = 'Listo, se ha procesado tu compra, volveremos al menú principal.'
            break
        }

        this.modalContent = content
      }
    },
    clearErrors () {
      this.errors = {}
    },
    disableButton () {
      this.isButtonDisabled = true
    },
    enableButton () {
      this.isButtonDisabled = false
    },
    onModalClose: function () {
      this.showModal = false
      this.$router.push('/vehicles')
    },
    async submitForm () {
      this.showConfirmationModal = false
      this.isProcessing = true

      await this.performPayment()
    },
    closeConfirmationModal () {
      this.showConfirmationModal = false
      this.enableButton()
    },
    validateForm () {
      this.disableButton()
      this.clearErrors()

      if (!this.cardNumber) {
        this.errors = {
          ...this.errors,
          cardNumber: [
            'El número de tarjeta no es válido'
          ]
        }
      }
      if (!this.cardExpirationDate) {
        this.errors = {
          ...this.errors,
          cardExpirationDate: [
            'La fecha de expiración de la tarjeta no es válida'
          ]
        }
      }
      if (!this.cardCvv || this.cardCvv.length < 3) {
        this.errors = {
          ...this.errors,
          cardCvv: [
            'La clave de verificación(CVV) de la tarjeta no es válida'
          ]
        }
      }

      if (Object.keys(this.errors).length === 0) {
        if (this.showDisplayTutorial) {
          this.showConfirmationModal = true
          return
        }
        this.isProcessing = true
        this.submitForm()
      }

      this.enableButton()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#car-detail {
  color: $grey;
  text-align: start;
  margin: 1rem 2rem;
}

.title {
  text-align: start;
  color: $grey;
}

.link {
  color: $blue;
  text-decoration: none;
  font-style: italic;
}

.card {
  border-radius: 25px;
  background-color: $white;
  width: 80%;
}

.card.with-form {
  width: 80%;
}

.card-section {
  padding: 1.25rem 2rem;
}

.vehicle-information {
  width: 25%;
}

.center-text {
  text-align: center;
}

.btn {
  font-size: 0.75rem;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  border: 1px solid $light-blue;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }

  &.accept {
    color: $white;
    margin-left: 1rem;
    background-color: $light-blue;
  }

  &.cancel {
    margin-right: 1rem;
    color: $light-blue;
    background-color: $white;
  }

  &:disabled {
    background-color: #8f919d;
    border: 1px solid #8f919d;
    cursor: inherit;
  }
}

hr {
  border: 1px solid $grey;
  margin-block-start: 1.25rem;
  margin-block-end: 1.25rem;
  margin-inline-start: 0;
  margin-inline-end: 0;
}

@media screen and (max-width: 60rem) {
  .link {
    display: none;
  }

  .card {
    width: 100%;
  }

  .vehicle-information {
    width: auto;
  }

  .btn {
    &.accept {
      margin-left: 0;
    }

    &.cancel {
      margin-right: 0;
    }
  }

  h2 {
    font-size: 1.25rem;
  }

  hr {
    margin-block-start: 0rem;
    margin-block-end: 0rem;
    margin-inline-start: 1.25rem;
    margin-inline-end: 1.25rem;
  }
}
</style>
